<template>
  <div style="background: #00946b" class="flexpers">
    <v-container style="margin-top: auto; margin-bottom: auto">
      <div>
        <v-card rounded="xl">
          <v-row class="my-auto" style="background: #fff">
            <v-col cols="12" class="credential-content px-6 py-4 rounded-xl">
              <v-row>
                <v-col cols="12" class="pb-0">
                  <v-btn
                    style="float: left"
                    :color="
                      homologateStatusWithColor('ACTIVE').color
                    "
                    width="auto"
                    :loading="load"
                    class="
                      font-weight-black
                      mx-auto
                      text-capitalize
                      font-weight-bold
                      rounded-pill
                    "
                  >
                    ACTIVO
                  </v-btn>
                </v-col>
                <v-col cols="12" class="pt-0 pb-4 text-center">
                  <v-avatar color="#fbb406" size="100" class="mx-auto mt-4">
                    <span
                      style="color: white; font-weight: bold; font-size: 20px"
                      >Test</span
                    >
                  </v-avatar>
                  <v-card-title
                    class="px-0 py-1 align-center justify-center"
                    style="
                      font-size: 1.2rem;
                      word-break: break-word;
                      font-weight: 600;
                    "
                  >
                    testName testLastname
                  </v-card-title>
                  <hr class="hr_color mt-5" />
                </v-col>
                <v-col cols="12">
                  <div class="d-flex py-1">
                    <v-icon color="black" class="pr-2"> mdi-domain </v-icon>
                    <span class="h5">
                      Test Company
                    </span>
                  </div>
                  <div class="d-flex py-1">
                    <v-img
                      src="@/assets/images/landing/memberLanding/ico-telefono.svg"
                      max-width="25"
                      contain
                      class="mr-2"
                    />
                    <span class="h5">
                      N/D
                    </span>
                  </div>
                  <div class="d-flex py-1">
                    <v-img
                      src="@/assets/images/landing/memberLanding/ico-email.svg"
                      max-width="25"
                      contain
                      class="mr-2"
                    />
                    <span class="h5">
                      test@email.com
                    </span>
                  </div>
                </v-col>
              </v-row>

              <hr class="hr_color mt-5" />

              <div class="association-section text-center">
                <div class="font-weight-black upercase mb-3">MIEMBRO DE</div>
                <v-avatar size="100" class="hr_color">
                  <span
                    style="color: white; font-weight: bold; font-size: 20px"
                  >
                    Test Company
                  </span>
                </v-avatar>
              </div>
            </v-col>
          </v-row>
        </v-card>
      </div>
    </v-container>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from "vuex";
import { homologateStatusWithColor } from "@/common/hook/useHelper.js";

export default {
  name: "DataSheetPrev",
  props: {
    memberData: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      cred: {},
      credInfo: {},
      personalInfo: [],
      directions: [],
      asociado: [],
      profile: "",
      backId: "",
      load: false,
    };
  },
  computed: {
    ...mapState("user", ["user"]),
  },
  methods: {
    ...mapActions("microsite", ["getMemberInformation"]),
    ...mapMutations("loader", ["loading", "loaded"]),
    homologateStatusWithColor,
  },
};
</script>


<style scoped>
.flexpers {
  display: flex;
  overflow-y: auto;
  height: 100vh;
}
.v-main__wrap {
  background: aliceblue !important;
}
.hr_color {
  border: 1px solid #c4c6c8;
}
.credential-content {
  background: #f8fafc;
}
.association-section {
  padding: 8px 0 4px;
}
.upercase {
  text-transform: uppercase !important;
}
</style>
